import React from 'react'
import { Header } from 'styles/algolia/collection/header'
import { Row } from 'styles/general'
import Actions from './Actions'
import FilterButton from './FilterButton'
import HeaderInfo from './HeaderInfo'
import OwnerInfo from './OwnerInfo'

export default (): React.ReactElement<React.ComponentProps<any>, any> => (
  <Header>
    <div data-type='header-owner-container'>
      <HeaderInfo />
      <OwnerInfo />
    </div>

    <Row>
      <FilterButton />

      <Actions />
    </Row>
  </Header>
)
